import { memo, useCallback } from "react";
import {
    numberCommaFormatter,
    statFormatter
} from "@helpers/utils";

import CustomTooltip from "../../ui-components/tooltip";
import ImageWrapper from "../../ui-components/image-wrapper";
// ** Third Party
import Proptypes from "prop-types";
import { Stats } from "@trackier/cloudstuff-ui";
import classnames from "classnames";

const StatsFormatter = ({
    className,
    num,
    id,
    suffix = "",
    prefix = "",
    customTooltipContent = null,
    max = null,
    enableCustomFormatting = true
}) => {
    // Using useMemo to generate the tooltipId only once when the component mounts
    // const tempId = useMemo(() => {
    //     return `${generateRandomString(4)}${id}`?.replace(/[\s()\-/./]/g, "");
    // }, [id]);

    const isNegative = num < 0;

    const formatNumber = useCallback(
        (number) => {
            const absFormatted = statFormatter(Math.abs(number));
            const formatted = max && Math.abs(number) >= max ? `${absFormatted}+` : absFormatted;
            return formatted;
        },
        [max]
    );

    const baseFormattingFn = (num) => {
        const decimals = num === Math.floor(num) ? 0 : 2;
        return num
            .toFixed(decimals)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const computedPrefix = isNegative ? `-${prefix}` : prefix;

    return (
        <>
            <span
                className={classnames("d-flex align-items-center", className)}
                id={id}>
                <Stats
                    start={enableCustomFormatting ? 0 : num}
                    end={num}
                    delay={0}
                    prefix={computedPrefix}
                    duration={1000}
                    runOnce={false}
                    {...(enableCustomFormatting ? { formattingFn: formatNumber } : { formattingFn: baseFormattingFn })}
                    suffix={suffix}/>
                {customTooltipContent ? (
                    <ImageWrapper
                        className="ms-25"
                        src={"common/info-circle.svg"}/>
                ) : null}
            </span>
            {id && (
                <>
                    {!customTooltipContent && num > 10000 && (
                        <CustomTooltip target={id} content={numberCommaFormatter(num)} />
                    )}
                    {customTooltipContent && (
                        <CustomTooltip target={id} content={customTooltipContent} />
                    )}
                </>
            )}
        </>
    );
};

StatsFormatter.propTypes = {
    num                   : Proptypes.number.isRequired,
    id                    : Proptypes.string.isRequired,
    suffix                : Proptypes.string,
    prefix                : Proptypes.string,
    customTooltipContent  : Proptypes.any,
    enableCustomFormatting: Proptypes.bool,
    max                   : Proptypes.number
};

export default memo(StatsFormatter);
